import { inject, Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CommunicationService } from '../../../http/communication.service';
import {DeckGenerationPayload, DeckGenerationResponse, DeckQuestionsPayload} from './strategy-deck.models';

const DECK_QUESTIONS_API = '/strategy-deck';

@Injectable({
  providedIn: 'root'
})
export class StrategyDeckService {

  private readonly communicationService = inject(CommunicationService);

  public getDeckQuestions(): Observable<DeckQuestionsPayload> {
    return this.communicationService.httpGet<DeckQuestionsPayload>(`${DECK_QUESTIONS_API}/questions`).pipe(
      catchError((error) => {
        console.error('Error fetching deck questions', error);
        throw error;
      })
    );
  }

  public generateDeck(payload: DeckGenerationPayload): Observable<DeckGenerationResponse> {
    return this.communicationService.httpPost<DeckGenerationResponse>(`${DECK_QUESTIONS_API}/generate`, payload).pipe(
      catchError((error) => {
        console.error('Error generating deck', error);
        throw error;
      })
    )
  }
}
